export default {
  mutations: {
    SET_PAYOUT_STATUS_LIST: 'SET_PAYOUT_STATUS_LIST',
  },
  getters: {
    GET_PAYOUT_STATUS_LIST: 'GET_PAYOUT_STATUS_LIST',
  },
  actions: {
    PAYOUT_STATUS_LIST: 'PAYOUT_STATUS_LIST',
  },
};
